module.exports = __webpack_public_path__ + "img/location.6735ca1b.png";